import { editCategoryRequest, editCategoryRequestSuccess, editCategoryRequestError } from "../../slices/Category/EditCategorySlice";
import axiosInstance from "../../../api/axiosInstance";
import { endpoints } from "../../../services/endpoints";

export const EditCategoryAPI = (data) => {
    const url = `${endpoints.editCategory}`; 
    return async (dispatch) => {
        try {
            dispatch(editCategoryRequest());
            const response = await axiosInstance({
                method: "PUT", 
                url: url,
                data: data,
                headers: { "Content-Type": "multipart/form-data" }, // Remove or comment out for FormData
            })
            return dispatch(editCategoryRequestSuccess(response?.data));
        } catch (error) {
            const _error = {
                data: error?.response?.data?.message || error?.message,
                status: error?.response?.status || error?.status,
            };
            return dispatch(editCategoryRequestError(_error));
        }
    };
};